import { apiClient, ApiError } from '@shoots/auth'
import type { Invite, InviteResponseRequest, RSVPResponse } from '../types'

function messageFromApiError(error: unknown, fallback: string): string {
  if (error instanceof ApiError && error.message) {
    try {
      const body = JSON.parse(error.message)
      if (body && typeof body.error === 'string') return body.error
    } catch {
      // not JSON — fall through
    }
  }
  return fallback
}

export class InviteService {
  /**
   * Fetch invite information by invite ID
   */
  async getInvite(inviteId: string): Promise<Invite> {
    try {
      const response = await apiClient.get<Invite>(
        `/functions/v1/invite?invite_id=${inviteId}`
      )
      return response
    } catch (error) {
      console.error('Failed to fetch invite:', error)
      throw new Error('Failed to fetch invite information')
    }
  }

  /**
   * Respond to an invite (accept or decline)
   */
  async respondToInvite(
    inviteId: string,
    response: 'yes' | 'no'
  ): Promise<RSVPResponse> {
    try {
      const requestData: InviteResponseRequest = {
        invite_id: inviteId,
        response,
      }

      const apiResponse = await apiClient.post<RSVPResponse>(
        '/functions/v1/invite',
        requestData
      )
      return apiResponse
    } catch (error) {
      console.error('Failed to respond to invite:', error)
      throw new Error(messageFromApiError(error, 'Failed to respond to invite'))
    }
  }
}

export const inviteService = new InviteService()
